import axios, { AxiosResponse } from "axios";
import { Observable, Subscriber, BehaviorSubject } from "rxjs";
import * as querystring from "querystring";
import { sessionStorageInstance } from "../storage/Storage";
import { VerifyRegisterDev } from "../../pages/register-dev/VerifyRegisterDev";
import { GoogleTagManagerService } from '../analitycs/GoogleTagManagerService';
import { TermsAndConditionsManager } from '../termsAndConditions/TermsAndConditionsManager';
import { ConfigProvider } from '../configuration/ConfigProvider';
import { dataStore } from '../storage/DataStore';
import StateContextProvider from '../../context/StateContext';
import { HTTPResponses } from '../../models/HTTPResponses';

export enum LoginApiState {
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGIN_CHANGE_PASSWORD,
  LOGIN_SUCCESS_WITH_SHOW_TC,
  LOGIN_DEVELOPER_SUCCESS
}

export enum ChangePasswordStatus {
  CHANGE_PWD_SUCCESS,
  CHANGE_PWD_SESSION_EXPIRED,
  CHANGE_PWD_500_STATUS,
  CHANGE_PWD_ERROR,
}

export class AuthService {
  private config: any = null;
  private static instance: AuthService;
  private static clientId: string = "MPOSClientRopc";
  private static scope: string = "MPOSApplicationRopc.microservices";
  private userAuthed: BehaviorSubject<boolean>;

  private constructor() {
    this.config = ConfigProvider.getInstance().getConfiguration(); this.userAuthed = new BehaviorSubject<boolean>(this.isLogged());

  }

  public getUserAuthedObservable(): Observable<boolean> {
    return this.userAuthed.asObservable();
  }

  public notifyUserUnauthenticated() {
    this.clearData();
    this.userAuthed.next(false);
  }

  public static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  login(username: string, password: string, recaptchaToken: string): Observable<LoginApiState> {
    // @ts-ignore
    if (this.config.mockData) {
      return this.loginMock();
    } else {
      return new Observable((subscriber: Subscriber<LoginApiState>) => {
        let http = axios.create();
        let body = {
          grant_type: "PASSWORD",
          client_id: AuthService.clientId,
          scope: AuthService.scope,
          username: username,
          password: password,
        };
        // @ts-ignore
        http.post(this.config.loginApi, querystring.stringify(body), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "x-oauth-identity-domain-name": "MPOSIdentityDomainRopc",
            "slider": recaptchaToken
          }
        }).then(response => {
          dataStore.publishTabSelectionData(false);
          if (response.status === 200) {
            this.userAuthed.next(true);
            let tokenScope = response.data['scope'];
            StateContextProvider.getInstance().setProp('scope', tokenScope);
            window.sessionStorage.setItem('scope', tokenScope);
            if (tokenScope === 'MPOS_ChangePassword') {
              let tokenForChangePwd = response.data['access_token'];
              sessionStorageInstance.setData('b', tokenForChangePwd);
              sessionStorageInstance.setData('c', password);
              GoogleTagManagerService.getInstance().pushGenericEvent('login', { result: 'ok', message: 'imposta password personale', type: 'credenziali provvisorie' });
              subscriber.next(LoginApiState.LOGIN_CHANGE_PASSWORD);
            } else if (tokenScope === 'MPOS_DEVELOPER') {
              let tokenForChangePwd = response.data['access_token'];
              sessionStorageInstance.setData('a', tokenForChangePwd);
              subscriber.next(LoginApiState.LOGIN_DEVELOPER_SUCCESS);
            }
            else {
              let accessToken = response.data['access_token'];
              sessionStorageInstance.setData('a', accessToken);
              return TermsAndConditionsManager.getInstance().showTermsAndCondition().then((result) => {
                if (result) {
                  return subscriber.next(LoginApiState.LOGIN_SUCCESS_WITH_SHOW_TC);
                } else {
                  return subscriber.next(LoginApiState.LOGIN_SUCCESS);
                }
              }).catch(() => {
                return subscriber.next(LoginApiState.LOGIN_SUCCESS);
              })
            }
          } else {
            this.userAuthed.next(false);
            subscriber.next(LoginApiState.LOGIN_ERROR);
          }
        }).catch(error => {
          let errorResponse: AxiosResponse = error.response;
          if (errorResponse !== undefined) {
            this.userAuthed.next(false);
            if (errorResponse.status === 401) {
              GoogleTagManagerService.getInstance().pushPageLogin(
                'login',
                {
                  result: 'ko',
                  message: errorResponse.data.errmsg
                },
                null,
                {
                  total: null,
                  active: null
                },
                {
                  total: null,
                  active: null
                },
                { total: null },
                null,
              );

              if (errorResponse.data !== undefined && errorResponse.data.errcode !== undefined) {
                let errorCodeFromResponse = errorResponse.data.errcode;
                if (errorCodeFromResponse === "4" || errorCodeFromResponse === "28" || errorCodeFromResponse === "30") {
                  subscriber.next(LoginApiState.LOGIN_ERROR);
                } else {
                  GoogleTagManagerService.getInstance().pushGenericError(
                    "Il servizio non è disponibile. Riprova più tardi",
                    errorResponse.status.toString(),
                    errorResponse.statusText
                  );
                  subscriber.error(errorResponse);
                }
              } else {
                GoogleTagManagerService.getInstance().pushPageLogin(
                  "login",
                  {
                    result: "ko",
                    message: errorResponse.data.errmsg,
                  },
                  null,
                  {
                    total: null,
                    active: null,
                  },
                  {
                    total: null,
                    active: null,
                  },
                  { total: null },
                  null
                );

                GoogleTagManagerService.getInstance().pushGenericError(
                  "Il servizio non è disponibile. Riprova più tardi",
                  errorResponse.status.toString(),
                  errorResponse.statusText
                );
                subscriber.error(errorResponse);
              }
            } else {
              GoogleTagManagerService.getInstance().pushPageLogin(
                'login',
                {
                  result: 'ko',
                  message: errorResponse.data.errmsg
                },
                null,
                {
                  total: null,
                  active: null
                },
                {
                  total: null,
                  active: null
                },
                { total: null },
                null
              );

              GoogleTagManagerService.getInstance().pushGenericError('Il servizio non è disponibile. Riprova più tardi', errorResponse.status.toString(), errorResponse.statusText);
              subscriber.error(errorResponse);
            }
          } else {
            GoogleTagManagerService.getInstance().pushGenericError('Il servizio non è disponibile. Riprova più tardi', '999', 'Generic error');
            this.userAuthed.next(false);
            subscriber.error(errorResponse);
          }
        }).finally(() => {
          subscriber.complete();
        })
      });
    }
  }

  loginMock(): Observable<LoginApiState> {
    return new Observable((subscriber: Subscriber<LoginApiState>) => {
      subscriber.next(LoginApiState.LOGIN_SUCCESS);
    });
  }

  changePasswordMock(): Observable<ChangePasswordStatus> {
    return new Observable((subscriber: Subscriber<ChangePasswordStatus>) => {
      subscriber.next(ChangePasswordStatus.CHANGE_PWD_ERROR);
    });
  }

  changePassword(newPassword: string): Observable<ChangePasswordStatus> {
    // @ts-ignore
    if (this.config.mockData) {
      return this.changePasswordMock();
    } else {
      let oldPassword = sessionStorageInstance.getData("c");
      let changePwdToken = sessionStorageInstance.getData("b")!;
      return new Observable((subscriber: Subscriber<ChangePasswordStatus>) => {
        let http = axios.create();
        let body = {
          password: oldPassword,
          newPassword: newPassword,
        };
        // @ts-ignore
        let url = this.config.baseApi + this.config.endpoints.changePassword;
        http.post(url, body, {
          headers: {
            "Authorization": "Bearer " + changePwdToken
          }
        }).then((response) => {
          if (response.status === 200) {
            let accessToken = response.data['access_token'];
            sessionStorageInstance.setData('a', accessToken);
            sessionStorageInstance.removeData('b');
            sessionStorageInstance.removeData('c');
            subscriber.next(ChangePasswordStatus.CHANGE_PWD_SUCCESS);
          } else {
            if (response.status === 400) {
              subscriber.next(ChangePasswordStatus.CHANGE_PWD_ERROR);
            } else if (response.status === 401) {
              subscriber.next(ChangePasswordStatus.CHANGE_PWD_SESSION_EXPIRED);
            } else {
              if (response.status === 400) {
                subscriber.next(ChangePasswordStatus.CHANGE_PWD_ERROR);
              } else if (response.status === 401) {
                subscriber.next(ChangePasswordStatus.CHANGE_PWD_SESSION_EXPIRED);
              } else {
                subscriber.next(ChangePasswordStatus.CHANGE_PWD_500_STATUS);
              }
            }
          }
        }).catch(error => {
          let errorResponse: AxiosResponse = error.response;
          if (errorResponse !== undefined) {
            const status = errorResponse.status;
            if (status === 400) {
              subscriber.next(ChangePasswordStatus.CHANGE_PWD_ERROR);
            } else if (status === 401) {
              subscriber.next(ChangePasswordStatus.CHANGE_PWD_SESSION_EXPIRED);
            } else {
              console.log("Change password error response: " + JSON.stringify(error));
              subscriber.error(error);
            }
          } else {
            subscriber.error(error);
          }
        }).finally(() => {
          this.userAuthed.next(true);
          subscriber.complete();
        });
      });
    }
  }

  changePasswordFromReset(password: string, confirmPassword: string, ott: string): Observable<HTTPResponses> {
    if (this.config.mockData) {
      return new Observable((subscriber: Subscriber<HTTPResponses>) => {
        subscriber.next(HTTPResponses.KO);
      });
    } else {
      return new Observable((subscriber: Subscriber<HTTPResponses>) => {
        let http = axios.create();
        let body = {
          password: password,
          password_confirm: confirmPassword,
        };
        const basePath = this.config.guestApi;
        let url = basePath + this.config.endpoints.resetPasswordGuest.replace("{OTT}", ott);
        http.post(url, body).then((response) => {
          if (response.status === 200) {
            subscriber.next(HTTPResponses.OK);
          } else if (response.status === 401) {
            subscriber.next(HTTPResponses.EXPIRED)
          } else {
            subscriber.next(HTTPResponses.KO);
          }
        }).catch(error => {
          console.log('error', error);
          let errorResponse: AxiosResponse = error.response;
          if (errorResponse !== undefined) {
            const status = errorResponse.status;
            if (status === 400) {
              subscriber.next(HTTPResponses.KO);
            } else if (status === 401) {
              subscriber.next(HTTPResponses.EXPIRED);
            } else {
              subscriber.next(HTTPResponses.KO);
            }
          } else {
            subscriber.error(error);
          }
        }).finally(() => {
          subscriber.complete();
        });
      });
    }
  }

  requestDeveloperAccount(
    additionalInfo: string,
    companyAddress: string,
    companyName: string,
    companyMonetaryValue: string,
    companyWebsite: string,
    fullname: string,
    email: string,
    phone: string,
  ): Observable<VerifyRegisterDev> {
    if (this.config.mockData) {
      return new Observable((subscriber: Subscriber<VerifyRegisterDev>) => {
        subscriber.next(VerifyRegisterDev.USED);
      });
    } else {
      return new Observable((subscriber: Subscriber<VerifyRegisterDev>) => {
        let http = axios.create();
        let body = {
          additionalInfo: additionalInfo,
          companyAddress: companyAddress,
          companyName: companyName,
          companyMonetaryValue: companyMonetaryValue,
          companyWebsite: companyWebsite,
          fullname: fullname,
          email: email,
          phone: phone,
        };

        let url = this.config.baseApi + this.config.endpoints.requestDeveloperAccount;

        http
          .post(url, body)
          .then((response) => {
            if (response.status === 200) {
              subscriber.next(VerifyRegisterDev.OK);
            } else if (response.status === 400) {
              subscriber.next(VerifyRegisterDev.USED);
            } else {
              subscriber.next(VerifyRegisterDev.KO);
            }
          })
          .catch((error) => {
            if (error.response.status === 400 && /already/.test(error.response.data.message)) {
              subscriber.next(VerifyRegisterDev.USED);
            } else {
              subscriber.error(VerifyRegisterDev.KO);
            }
          })
          .finally(() => {
            subscriber.complete();
          });
      });
    }
  }

  isLogged(): boolean {
    StateContextProvider.getInstance().setProp('scope', window.sessionStorage.getItem('scope'));
    this.config.mockData && sessionStorageInstance.setData('scope', 'MPOS_DEVELOPER');
    // this.config.mockData && sessionStorageInstance.setData('scope', 'MPOS_admin');
    return this.config.mockData || sessionStorageInstance.hasKey('a') || sessionStorageInstance.hasKey('b');
  }

  logout(): Observable<void> {
    return Observable.create((subscriber: Subscriber<void>) => {
      sessionStorageInstance.removeData("a");
      sessionStorageInstance.removeData("b");
      sessionStorageInstance.clear();
      subscriber.complete();
    });
  }

  private clearData() {
    if (sessionStorageInstance.hasKey("a")) {
      sessionStorageInstance.removeData("a");
      sessionStorageInstance.removeData("b");
    }
  }
}
